// Replicated Site Handler
(function() {
    'use strict';
    
    // Configuration - Update these values for your environment
    const FLIGHT_API_BASE_URL = 'https://flight-dev.sweetskiesify.com'; // Update this to match your environment
    const WEBSITE_ID = 1; // Update with your website ID
    
    // Get replicated site name from URL parameter or localStorage
    function getReplicatedSiteName() {
      // Check URL parameter first
      const urlParams = new URLSearchParams(window.location.search);
      const urlParam = urlParams.get('u');
      
      if (urlParam) {
        localStorage.setItem('replicatedSiteName', urlParam);
        return urlParam;
      }
      
      // If no URL parameter, return stored value (don't clear on home page)
      return localStorage.getItem('replicatedSiteName');
    }
    
    // Clear all consultant data from localStorage
    function clearConsultantData() {
      localStorage.removeItem('consultantData');
      localStorage.removeItem('consultantDisplayID');
      localStorage.removeItem('consultantDisplayName');
      localStorage.removeItem('replicatedSiteName');
      
      // Remove banner if it exists
      const banner = document.getElementById('shopping-with-banner');
      if (banner) {
        banner.remove();
      }
    }
    
    // Call Flight API to get consultant information
    async function fetchConsultantInfo(replicatedSiteName) {
      if (!replicatedSiteName) {
        return null;
      }
      
      try {
        // IMPORTANT: Use POST method as required by the API endpoint
        const apiUrl = `${FLIGHT_API_BASE_URL}/api/Website/GetConsultantReplicationSiteInfo?url=${encodeURIComponent(replicatedSiteName)}&websiteId=${WEBSITE_ID}&returnIfBlocked=false`;
        
        const response = await fetch(apiUrl, {
          method: 'POST', // CRITICAL: Must be POST, not GET
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          mode: 'cors', // Enable CORS
          cache: 'no-cache',
          credentials: 'omit' // Don't send cookies
        });
        
        if (!response.ok) {
          console.error('Failed to fetch consultant info:', response.status, response.statusText);
          const errorText = await response.text();
          console.error('Response:', errorText);
          return null;
        }
        
        const data = await response.json();
        
        // Validate response
        if (data && data.DisplayID && !data.BlockWebsite) {
          return data;
        }
        
        return null;
      } catch (error) {
        console.error('Error fetching consultant info:', error);
        console.error('Error details:', error.message);
        return null;
      }
    }
    
    // Store consultant data in localStorage
    function storeConsultantData(consultantData, replicatedSiteName) {
      if (consultantData) {
        localStorage.setItem('consultantData', JSON.stringify(consultantData));
        localStorage.setItem('consultantDisplayID', consultantData.DisplayID || '');
        localStorage.setItem('consultantDisplayName', consultantData.DisplayName || '');
        localStorage.setItem('replicatedSiteName', replicatedSiteName);
      }
    }
    
    // Add consultant DisplayID to cart attributes
    function addConsultantToCart() {
      const consultantDisplayID = localStorage.getItem('consultantDisplayID');
      
      if (!consultantDisplayID) {
        return;
      }
      
      // Add as cart attribute (available in checkout)
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'consultant_display_id': consultantDisplayID
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Consultant DisplayID added to cart:', consultantDisplayID);
      })
      .catch(error => {
        console.error('Error adding consultant to cart:', error);
      });
    }

    function buildReplicatedSiteFromEmail(email) {
  if (!email || typeof email !== 'string') return '';
  const localPart = email.split('@')[0] || '';
  return localPart
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

function getLoggedInConsultantContext() {
  const ctx = window.AloetteCustomerContext;
  if (!ctx || !ctx.isLoggedIn || !ctx.isConsultant) return null;

  const email = (ctx.email || '').trim();
  const replicatedSiteName = buildReplicatedSiteFromEmail(email);
  if (!replicatedSiteName) return null;

  return {
    replicatedSiteName,
    displayName: (ctx.displayName || '').trim() || email || 'Consultant'
  };
}
    
    // Initialize on page load
    async function init() {

  const loggedIn = getLoggedInConsultantContext();
  if (loggedIn) {
    clearConsultantData();

    const flightData = await fetchConsultantInfo(loggedIn.replicatedSiteName);

    if (flightData && flightData.DisplayID && !flightData.BlockWebsite) {
      // IMPORTANTE: aquí DisplayID ya es el de Flight
      storeConsultantData(flightData, loggedIn.replicatedSiteName);
      updateUI(flightData);
      addConsultantToCart();
      return;
    }

    // Fallback visual (sin ID Shopify para no contaminar)
    const fallback = {
      DisplayID: '',
      DisplayName: loggedIn.displayName,
      Url: loggedIn.replicatedSiteName
    };
    storeConsultantData(fallback, loggedIn.replicatedSiteName);
    updateUI(fallback);
    return;
  }
      const currentReplicatedSiteName = getReplicatedSiteName();
      const storedReplicatedSiteName = localStorage.getItem('replicatedSiteName');
      const urlParams = new URLSearchParams(window.location.search);
      const urlParam = urlParams.get('u');
      const isRootPath = window.location.pathname === '/' || window.location.pathname === '';
      
      // If there's a URL parameter with a different consultant, clear old data
      if (urlParam && storedReplicatedSiteName && storedReplicatedSiteName !== urlParam) {
        console.log(`Replicated site changed from "${storedReplicatedSiteName}" to "${urlParam}", clearing old data`);
        clearConsultantData();
        // Update currentReplicatedSiteName to the new one
        const newReplicatedSiteName = urlParam;
        
        // Fetch new consultant information
        console.log('Fetching consultant info for:', newReplicatedSiteName);
        const consultantData = await fetchConsultantInfo(newReplicatedSiteName);
        
        if (consultantData) {
          storeConsultantData(consultantData, newReplicatedSiteName);
          updateUI(consultantData);
          addConsultantToCart();
        } else {
          // Consultant not found or blocked - clear all stored data
          console.log('Consultant not found or blocked, clearing all data');
          clearConsultantData();
        }
        return;
      }
      
      // If no replicated site name in URL or localStorage, don't do anything (keep existing data)
      if (!currentReplicatedSiteName) {
        // If we have stored data, use it (don't clear on home page)
        const storedData = localStorage.getItem('consultantData');
        if (storedData) {
          try {
            const consultantData = JSON.parse(storedData);
            if (consultantData && consultantData.DisplayID) {
              console.log('Using stored consultant data (no URL parameter, on home page)');
              updateUI(consultantData);
              addConsultantToCart();
              return;
            }
          } catch (e) {
            console.log('Invalid stored data, but not clearing on home page');
          }
        }
        return; // No consultant data to work with
      }
      
      // Check if we have valid consultant data for the current replicated site
      const storedData = localStorage.getItem('consultantData');
      if (storedData && storedReplicatedSiteName === currentReplicatedSiteName) {
        try {
          const consultantData = JSON.parse(storedData);
          // Verify data is still valid and matches current site
          if (consultantData && consultantData.DisplayID && consultantData.Url === currentReplicatedSiteName) {
            console.log('Using stored consultant data for:', currentReplicatedSiteName);
            updateUI(consultantData);
            addConsultantToCart();
            return;
          } else {
            // Stored data doesn't match, clear it and fetch fresh
            console.log('Stored data doesn\'t match current site, fetching fresh data');
            clearConsultantData();
          }
        } catch (e) {
          // Invalid stored data, clear it and fetch fresh
          console.log('Invalid stored data, clearing and fetching fresh');
          clearConsultantData();
        }
      }
      
      // Fetch consultant information from Flight API
      console.log('Fetching consultant info for:', currentReplicatedSiteName);
      const consultantData = await fetchConsultantInfo(currentReplicatedSiteName);
      
      if (consultantData) {
        storeConsultantData(consultantData, currentReplicatedSiteName);
        updateUI(consultantData);
        addConsultantToCart();
      } else {
        // Consultant not found or blocked - clear all stored data
        console.log('Consultant not found or blocked, clearing all data');
        clearConsultantData();
      }
    }
    
    // Update UI with consultant information
function updateUI(consultantData) {
  if (!consultantData || !consultantData.DisplayName) return;
  updateShoppingWithBanner(consultantData.DisplayName, consultantData.Url || '');
}

function updateShoppingWithBanner(displayName, consultantUrl) {
  let banner = document.getElementById('shopping-with-banner');
  if (!banner) {
    banner = document.createElement('div');
    banner.id = 'shopping-with-banner';
    banner.className = 'shopping-with-banner';
    banner.style.cssText = 'background-color: #000; color: #fff; padding: 8px 16px; text-align: center; font-size: 14px;';
    const header = document.querySelector('header') || document.body.firstElementChild;
    if (header && header.parentNode) header.parentNode.insertBefore(banner, header);
    else document.body.insertBefore(banner, document.body.firstChild);
  }

  const replicatedSiteName =
    consultantUrl ||
    localStorage.getItem('replicatedSiteName') ||
    new URLSearchParams(window.location.search).get('u') ||
    '';

  if (replicatedSiteName) {
    const profileUrl = `/pages/consultant-contact?u=${encodeURIComponent(replicatedSiteName)}`;
    banner.innerHTML = `Shopping with <a href="${profileUrl}" style="color: #fff; text-decoration: underline; font-weight: bold;">${displayName}</a>`;
  } else {
    banner.textContent = `Shopping with ${displayName}`;
  }
}

function buildReplicatedSiteFromEmail(email) {
  if (!email || typeof email !== 'string') return '';

  const localPart = email.split('@')[0] || '';

  return localPart
    .toLowerCase()
    .normalize('NFD')                 // separa acentos
    .replace(/[\u0300-\u036f]/g, '')  // elimina diacríticos
    .replace(/[^a-z0-9]/g, '');       // elimina caracteres especiales
}

function getLoggedInConsultant() {
  const ctx = window.AloetteCustomerContext;
  if (!ctx || !ctx.isLoggedIn || !ctx.isConsultant) return null;

  const email = (ctx.email || '').trim();
  const replicatedSiteName = buildReplicatedSiteFromEmail(email);
  const displayName = (ctx.displayName || '').trim() || email || 'Consultant';
  const displayId = ctx.customerId ? String(ctx.customerId) : '';

  return {
    DisplayID: displayId,
    DisplayName: displayName,
    Url: replicatedSiteName, // clave para que el link del banner funcione
    IsLoggedInConsultant: true
  };
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
    
    // Listen for cart updates to re-add consultant ID
    function setupCartListeners() {
      // Re-add consultant ID when cart is accessed or updated
      const consultantDisplayID = localStorage.getItem('consultantDisplayID');
      if (consultantDisplayID) {
        // Add immediately if on cart page
        if (window.location.pathname.includes('/cart')) {
          addConsultantToCart();
        }
        
        // Listen for cart drawer opens (common in Shopify themes)
        document.addEventListener('cart:updated', function() {
          addConsultantToCart();
        });
        
        // Also listen for custom events that themes might fire
        document.addEventListener('cart:refresh', function() {
          addConsultantToCart();
        });
      }
    }
    
    // Run initialization when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init();
        setupCartListeners();
      });
    } else {
      init();
      setupCartListeners();
    }
    
    // Export functions for use in other scripts
    window.ReplicatedSiteHandler = {
      getConsultantDisplayID: function() {
        return localStorage.getItem('consultantDisplayID') || '';
      },
      getConsultantDisplayName: function() {
        return localStorage.getItem('consultantDisplayName') || '';
      },
      getConsultantData: function() {
        const data = localStorage.getItem('consultantData');
        return data ? JSON.parse(data) : null;
      },
      // Export function to manually add consultant to cart
      addConsultantToCart: addConsultantToCart,
      // Export function to clear consultant data
      clearConsultantData: clearConsultantData
    };
  })();